<template>
    <div>
        <h2>MO'Drive Reparatur-Service</h2>
        Willst du den Reparatur-Service von MO'Drive inkl. gratis Leihauto und
        Hol- und Bringservice nutzen? <sup>1</sup>
        <base-select
            v-model="modrive"
            id="modrive"
            placeholder="Bitte wählen"
            interfaceValue="action-sheet"
        >
            <ion-select-option value="Ja">Ja</ion-select-option>
            <ion-select-option value="Nein">Nein</ion-select-option>
        </base-select>
        <!-- <div class="ion-margin-bottom" style="font-size: small;">
                        Einfach „Ja“ auswählen und du musst keine weiteren
                        Veranlassungen treffen – du wirst umgehend von MO'Drive
                        kontaktiert.
                    </div> -->
        <div style="font-size: small;">
            Wenn du „Ja“ wählst, wirst du umgehend nach dem Absenden von
            MO'Drive kontaktiert.
        </div>
        <template v-if="!$store.state.isLoggedIn && modrive === 'Ja'">
            <base-select
                v-model="modriveVersicherungsart"
                id="modrive-versicherungsart"
                label="KFZ-Versicherungsart *"
                class="ion-margin-top"
            >
                <ion-select-option value="Kaskoversicherung"
                    >Kaskoversicherung</ion-select-option
                >
                <ion-select-option value="Nur Haftpflicht"
                    >Nur Haftpflicht</ion-select-option
                >
            </base-select>
            <base-select
                v-model="modriveKfzart"
                id="modrive-kfzart"
                label="Fahrzeugtyp *"
            >
                <ion-select-option value="PKW">PKW</ion-select-option>
                <ion-select-option value="LKW">LKW</ion-select-option>
                <ion-select-option value="Motorrad">Motorrad</ion-select-option>
            </base-select>
            <div
                v-if="
                    modriveVersicherungsart === 'Nur Haftpflicht' ||
                    (modriveKfzart !== '' && modriveKfzart !== 'PKW')
                "
                class="ion-margin-top"
            >
                <ion-card class="-danger">
                    Der Reparatur-Service von MO'Drive ist leider nur für
                    Kaskokunden mit PKW möglich. Du fährst daher ohne MO'Drive
                    fort. Nähere Infos findest du
                    <a
                        href="#"
                        @click.prevent="
                            Browser.open({
                                url:
                                    'https://www.klickmal.at/mobilitaet/kfz-versicherung/mo-drive.html',
                            })
                        "
                        >hier</a
                    >.
                </ion-card>
            </div>
            <template v-if="isModriveLoggedOutPossible">
                <!-- <base-input
                    id="modrive-polizzenversicherung"
                    v-model="formData.polizzenversicherung"
                    type="text"
                    label="Polizzen-Nr. KFZ-Versicherung *"
                ></base-input> -->
                <!-- <base-input
                                id="modrive-fin"
                                v-model="formData.modriveFin"
                                type="text"
                                label="Fahrzeug-Identifizierungsnummer (FIN)"
                            ></base-input>
                            <base-datetime
                                label="Erstzulassungsdatum"
                                v-model="formData.modriveErstzulassungsdatum"
                                id="modrive-erstzulassungsdatum"
                                :showNativeInput="true"
                                placeholder="TT.MM.JJJJ"
                                infoText="Das Erstzulassungsdatum muss im Format TT.MM.JJJJ eingegeben werden."
                            ></base-datetime> -->
                <base-input
                    id="modrive-leistung"
                    v-model="modriveLeistung"
                    type="number"
                    label="Leistung in KW"
                ></base-input>
            </template>
        </template>
        <base-select
            v-model="modriveFahrtuechtig"
            id="modrive-fahrtuechtig"
            v-if="
                modrive === 'Ja' &&
                ($store.state.isLoggedIn || isModriveLoggedOutPossible)
            "
            label="Ist das Fahrzeug fahrtüchtig? *"
            class="ion-margin-top"
        >
            <ion-select-option value="Ja">Ja</ion-select-option>
            <ion-select-option value="Nein">Nein</ion-select-option>
        </base-select>
        <div class="ion-margin-top">
            <ion-card>
                <b>Deine MO'Drive Vorteile <sup>1</sup></b>
                <ul>
                    <li>
                        EUR 100,00 weniger Selbstbehalt
                        <sup>2</sup>
                    </li>
                    <li>
                        Kostenloses Ersatzfahrzeug für die Dauer der Reparatur
                    </li>
                    <li>Kostenloses Hol- und Bringservice</li>
                    <li>
                        Kostenlose Innen- und Außenreinigung
                    </li>
                    <li>
                        Reparatur nur mit Originalersatzteilen durch MO'Drive
                        Fachwerkstätten
                    </li>
                </ul>
                <span>
                    Bei Fragen, wende dich bitte an die
                    <a href="tel:+4317695690">MO’Drive 24-Stunden Hotline</a>
                    oder sende eine E-Mail an
                    <a href="mailto:termin@modrive.at">termin@modrive.at</a>.
                </span>
                <img
                    :src="
                        baseurl +
                        '/content/dam/klickmal/me1ns/images/modrive_logo.jpg'
                    "
                    class="c-modrive-logo"
                />
            </ion-card>
        </div>
        <base-checkbox
            v-model="modriveDatenschutz"
            v-if="
                modrive === 'Ja' &&
                ($store.state.isLoggedIn || isModriveLoggedOutPossible)
            "
            id="modrive-datenschutz"
            lines="none"
            label="Ich stimme zu, dass meine notwendigen personenbezogenen Daten zur Erbringung der Schadensbearbeitung von Wüstenrot automationsunterstützt verarbeitet und zu diesem Zweck an MO'Drive Wiesenthal Handel und Service GmbH übermittelt werden. MO'Drive sichert dir zu, dass deine Angaben entsprechend den geltenden <a href='https://modrive.at/datenschutz-impressum/' target='_blank' @click.stop>datenschutzrechtlichen Bestimmungen</a> vertraulich behandelt werden. *"
        ></base-checkbox>
        <div class="ion-text-center">
            <ion-button
                class="-round -add-padding"
                @click="emitChange"
                :disabled="
                    modrive === '' ||
                    ($store.state.isLoggedIn &&
                        modrive === 'Ja' &&
                        (modriveFahrtuechtig === '' ||
                            modriveDatenschutz === false)) ||
                    (!$store.state.isLoggedIn &&
                        modrive === 'Ja' &&
                        (modriveVersicherungsart === '' ||
                            modriveKfzart === '') || (isModriveLoggedOutPossible && (modriveFahrtuechtig === '' || modriveDatenschutz === false)))
                "
                >Weiter</ion-button
            >
        </div>
        <div style="font-size: small;" class="ion-padding-top">
            <p>
                <sup>1</sup> MO'Drive Service ist kostenlos für Wüstenrot
                KFZ-Kaskokunden im Fall einer Schadensdeckung durch die
                Wüstenrot Versicherungs-AG. Gilt nur für 2-spurige Fahrzeuge
                unter 7,5 Tonnen.
            </p>
            <p>
                <sup>2</sup> Ein allfälliger Selbstbehalt wird nur dann um den
                Betrag von 100 EUR (inkl USt) reduziert, wenn der
                Nettoreparaturumsatz am Fahrzeug pro Schadensfall den Betrag von
                600 EUR überschreitet.
            </p>
        </div>
    </div>
</template>

<script>
import { BASEURL } from "@/utils/globals";
import BaseSelect from "@/components/BaseSelect";
import BaseCheckbox from "@/components/BaseCheckbox";
import BaseInput from "@/components/BaseInput";
import { Plugins } from "@capacitor/core";

export default {
    components: {
        BaseSelect,
        BaseCheckbox,
        BaseInput,
    },
    data() {
        return {
            baseurl: BASEURL,
            modrive: "",
            modriveVersicherungsart: "",
            modriveLeistung: "",
            modriveFahrtuechtig: "",
            modriveDatenschutz: false,
            modriveKfzart: "",
            Browser: Plugins.Browser,
        };
    },
    computed: {
        isModriveLoggedOutPossible() {
            let result = false;
            if (
                this.modriveVersicherungsart === "Kaskoversicherung" &&
                this.modriveKfzart === "PKW"
            ) {
                result = true;
            }
            return result;
        },
    },
    methods: {
        emitChange() {
            if (
                !this.$store.state.isLoggedIn &&
                !this.isModriveLoggedOutPossible
            ) {
                this.modrive = "Nein";
            }
            this.$emit("change", [
                { id: "modrive", value: this.modrive },
                {
                    id: "modriveVersicherungsart",
                    value: this.modriveVersicherungsart,
                },
                { id: "modriveLeistung", value: this.modriveLeistung },
                { id: "modriveFahrtuechtig", value: this.modriveFahrtuechtig },
                { id: "modriveDatenschutz", value: this.modriveDatenschutz },
                { id: "modriveKfzart", value: this.modriveKfzart },
            ]);
        },
    },
};
</script>

<style lang="scss" scoped>
.c-modrive-logo {
    width: 120px;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    @media only screen and (max-width: $breakpoint-lg) {
        display: none;
    }
}
</style>
